import axios from 'axios';
import { Location } from '../types/location';

import { config } from '../config';

const API_URL = `${config.apiUrl}/api/locations`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
};

export const LocationService = {
  async getAllLocations(): Promise<Location[]> {
    const response = await axios.get(API_URL, getAuthHeaders());
    return response.data;
  },

  async addLocation(locationData: Omit<Location, '_id' | 'createdAt'>): Promise<Location> {
    const response = await axios.post(API_URL, locationData, getAuthHeaders());
    return response.data;
  },

  async updateLocation(_id: string, locationData: Omit<Location, '_id' | 'createdAt'>): Promise<Location> {
    const response = await axios.put(`${API_URL}/${_id}`, locationData, getAuthHeaders());
    return response.data;
  },

  async deleteLocation(_id: string): Promise<void> {
    await axios.delete(`${API_URL}/${_id}`, getAuthHeaders());
  }
};
